import type { ReactNode } from 'react'

import { IconSettings } from '../icons/index.js'
import { useSettingsStore } from '../store/index.js'
import './audio.css'

export function AudioSettings(): ReactNode {
  const sound = useSettingsStore((s) => s.sound)
  const music = useSettingsStore((s) => s.music)
  const set = useSettingsStore((s) => s.set)

  return (
    <div className="audio-settings" role="group" aria-label="声音设置">
      <label>
        <span>游戏音效</span>
        <input type="checkbox" checked={sound} onChange={(e) => set('sound', e.target.checked)} />
      </label>
      <label>
        <span>背景音乐</span>
        <input type="checkbox" checked={music} onChange={(e) => set('music', e.target.checked)} />
      </label>
    </div>
  )
}

/** 本地传手机模式没有房间信息面板，用一个轻量设置菜单承载同一组开关。 */
export function AudioMenu(): ReactNode {
  return (
    <details className="audio-menu">
      <summary aria-label="声音设置">
        <IconSettings size={18} />
        <span>声音</span>
      </summary>
      <div className="audio-menu__panel">
        <AudioSettings />
      </div>
    </details>
  )
}
